import { item } from './items';

export const items = [{
  type: 'heading',
  text: 'Heading',
  heading_type: 'h1'
  },
  {type:'email'},
  {
    type: 'youtube',
    video: ''
  }, {
    type: 'settings_panel',
    content: []
  },
  {
    type: 'iframe',
    url: ''
  },
  {
    type: 'break'
  },
  {
    type: 'icon',
    icon: 'font-awesome-flag '
  },
  {
    type: 'file_image'
  },
  {
    type: 'bulk_input'
  },
  {
    type: 'scaffold_json'
  },{
    type: 'table_like_columns',
    content: [
      [],
      []
    ]
  },
  {
    type: 'image',
    url: 'https://s3.us-east-2.amazonaws.com/k16-hosted-lib/default.jpg',
    text: 'Image'
  },
 /* {
    type: 'courseimage',
    url: 'https://s3.us-east-2.amazonaws.com/k16-hosted-lib/default.jpg',
    text: 'Image'
  },*/
  {
    type: 'data_visuals'
  },
  {
    type: 'flex',
    content: [{content:[]}, {content:[]}]
  },
  /*{
    type: "outcomes",
  },*/
  {
    type: 'outcomesedit',
    content: {
      text: {
        name: 'text'
      },
      target: {
        name: 'target'
      },
      level: {
        name: 'level'
      },
      term: {
        name: 'term'
      }
    }
  },
  {
    type: 'labeled_text',
    label: 'Text Label',
    form: true,
    name: 'default_text'
  },
  {
    type: 'text',
    text: ''
  },
  {
    type: 'edit_text',
    text: ''
  },
  {
    type: 'data_table',
    columns: [],
    data: [],
    list_view: []
  },
  {
    type: 'button'
  },
  {
    type: 'up_next'
  },
  {
    type: 'mentions'
  },
  {
    type: 'input',
    label: 'Input',
    input_type: 'text',
    form: true
  },
  {
    type: 'hidden_default',
    form: true
  },
  {
    type: 'switch',
    label: 'Switch Input',
    form: true
  },
  {
    type: 'check',
    label: 'Check Box',
    form: true
  },
  {
    type: 'radio',
    label: 'Radio Buttons',
    form: true,
    options: [{
      label: 'Option',
      value: 1

    },
    {
      label: 'Option',
      value: 2

    }
    ]
  },
  {
    type: 'select',
    label: 'Select List',
    form: true,
    options: [{
      label: 'Option',
      value: 1

    },
    {
      label: 'Option',
      value: 2

    },
    ]
  },
  {
    type: 'select_list_display',
    label: 'Select List Display',
    form: true,
    options: [
    ]
  },
  {
    type: 'date',
    label: 'Date Picker',
    form: true,
    data: [
      {
        name: 'courses.timezone'
      }
    ]
  },
  {
    type: 'date_display',
    label: 'Date Display',
    data: [
      {
        name: 'courses.timezone'
      }
    ]
  },
  {
    type: 'weekday',
    form: true
  },
  {
    type: 'panel',
    panel_type: 'default',
    content: []
  },
  {
    type: 'padding',
    content: []
  },
  {
    type: 'template',
    content: []
  },
  {
    type: 'well',
    content: []
  },
  {
    type: 'block_style',
    content: []
  },
  {
    type: 'gradebook',
    name:'id'
  },
  {
    type: 'row',
    title: 'Row',
    widths: [6, 6],
    content: [
      [],
      []
    ]
  },
  {
    type: 'accordion',
    title: 'Accordion',
    tabs: [{
      heading: 'Accordion 1',
      content: []

    },
    {
      heading: 'Accordion 2',
      content: []

    }
    ]
  },
  {
    type: 'list',
    title: 'List',
    list_view: [],
    content: [
    ]
  },/* {
    type: 'list_card',
    title: 'Card List',
    list_view: [],
    content: [
    ]
  }, {
    type: 'general_card',
    title: 'Card With Content',
    list_view: [],
    content: [
    ]
  }*/, {
    type: 'list_index',
    title: 'Index List',
    list_view: [],
    content: [
    ]
  },
  {
    type: 'create',
    title: 'Create Item'
  },
  {
    type: 'connection',
    title: 'Connection',
    allowed_types: [
    ]
  },
  {
    type: 'conditional',
    content: []
  },
  {
    type: 'role_conditional',
    roles: [],
    denied: false,
    content: []
  },
  {
    type: 'tabs',
    title: 'Tabs',
    tabs: [{
      heading: 'Tab 1',
      content: []

    },
    {
      heading: 'Tab 2',
      content: []

    }
    ]
  },
  {
    type: 'wizard',
    title: 'Wizard',
    tabs: [{
      heading: 'Page 1',
      content: []

    },
    {
      heading: 'Page 2',
      content: []

    }
    ]
  },
  {
    type: 'carousel',
    title: 'Carousel',
    slides: [{
      url: 'https://c1.staticflickr.com/4/3854/14668986874_a852c156b1_b.jpg',
      caption: 'Rock image 1'
    }, {
      url: 'https://c1.staticflickr.com/8/7142/6672213105_a059b7bdb9_b.jpg',
      caption: 'Rock image 2'
    }

    ]
  },
  {
    type: 'view',
    title: 'Open View',
    view: 'edit'
  },
  {
    type: 'direct_link',
    url: '',
    text: ''  },

  {
    type: 'link',
    url: '',
    text: '',
    content: []
  },
  {
    type: 'file_link',
  },
  {
    type: 'anchor',
    url: '',
    content: [{ type: 'text', name: 'text' }]
  },
   {
    type: 'filebrowser',

  },
  {
    type: 'attachment',

  },
  {
    type: 'editor',
    title: 'Scaffold Editor',
    name: 'scaffold',
    view: 'view'

  },
  {
    type: 'navigation',
    title: 'Navigation Frame',
    links: []
  },
  {
    type: 'integration',
    title: 'Integration type',
    integration_type: 'lms'
  },
  {
    type: 'menu',
    title: 'Item Menu',
    content: []
  },
  {
    type: 'data',

  }, {
    type: 'data_link_count'

  }, {
    type: 'learningcomponent',
    toload_mode: 'list'

  },
  {
    type: 'data_search',
    allow_search: true
  },
  {
    type: 'data_link'
  },
  {
    type: 'data_link_label'
  },
  {
    type: 'text_link_label'
  },
  {
    type: 'data_array',
    content: [],
    values: []
  }, {
    type: 'template_data_array',
    content: [],
    values: []
  },
  {
    type: 'item_link',
    item_type: {
    },
    item_id: {
    }
  },
  {
      type: 'phone_number',
      form: true
  },
  {
    type: 'lti_tool'
  },
  {type:'course_archive_progress'},
  {
    type: 'tableau'
  },
  {
    type: 'data_import'
  },
  {
    type: 'comment_filter'
  },
  {
    type: 'comment_list'
  },
  {
    type:'user_instance_select'},
  {
    type: 'rubric'
  },
  {
    type: 'integration_status'
  }
];
